module.exports = __webpack_public_path__ + "static/media/add_button.ba1c42b0.svg";